import {
  PERFORMING_LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  PERFORMING_LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE
} from './AuthConstants';
import AuthenticationHelper from 'shared/helpers/authenticationHelper';
import { resetStore } from 's1-ui/sovos-sliding-panel/store/SovosSlidingPanelStore';

const initialState = {
  user: {
    Username: '',
    Domain: '',
    Schema: '',
    Seghash: '',
    ClientName: '',
    LiteUsername: '',
    iat: 0
  },
  logged: false,
  errorMessage: '',
  loggingIn: false
};
const usableState = Object.assign({}, initialState);

if (AuthenticationHelper.isJwtTokenStored()) {
  usableState.user = AuthenticationHelper.getDecodedToken();
  usableState.logged = true;
}

export default function loginReducer(state = usableState, action) {
  switch (action.type) {
    case PERFORMING_LOGIN:
      return {
        ...state,
        loggingIn: true,
        logged: false
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: AuthenticationHelper.getDecodedToken(),
        loggingIn: false,
        logged: true
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loggingIn: false,
        logged: false,
        errorMessage: action.errorMessage
      };
    case PERFORMING_LOGOUT:
      return {
        ...state,
        loggingIn: false
      };
    case LOGOUT_SUCCESS:
      resetStore();
      return { ...initialState };
    case LOGOUT_FAILURE:
      return { ...initialState };
    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./src/redux/auth/AuthReducer.js